import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Checkbox } from "antd";
import styles from "./style.module.scss";

// pivony.com privacy policy per survey language (the site's localized slugs).
const PRIVACY_POLICY_URLS = {
  en: "https://pivony.com/privacy-policy",
  tr: "https://pivony.com/tr/gizlilik-politikasi",
  de: "https://pivony.com/de/datenschutzrichtlinie",
  es: "https://pivony.com/es/politica-privacidad",
  it: "https://pivony.com/it/informativa-privacy",
  ar: "https://pivony.com/ar/privacy-policy",
};

export const privacyPolicyUrl = (language) =>
  PRIVACY_POLICY_URLS[String(language || "").split("-")[0]] || PRIVACY_POLICY_URLS.en;

/**
 * The required KVKK / GDPR consent box of a survey with "Ask for consent" on. It names the survey
 * owner's company when the API sends one, otherwise it uses the generic wording.
 */
const ConsentCheckbox = ({ checked, onChange, company, language, invalid = false }) => {
  const name = String(company || "").trim();
  return (
    <Checkbox
      className={[styles.consent, invalid ? styles.consentInvalid : ""].filter(Boolean).join(" ")}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      aria-required="true"
      aria-invalid={invalid || undefined}
    >
      <Trans
        i18nKey={
          name
            ? "surveyManagement.public.consent_label_company"
            : "surveyManagement.public.consent_label_generic"
        }
        values={name ? { company: name } : undefined}
        components={[
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a
            href={privacyPolicyUrl(language)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          />,
        ]}
      />
    </Checkbox>
  );
};

/**
 * The start screen's consent box ("Ask for consent before starting"): the owner's own text, with a
 * link to their privacy notice when they gave one.
 */
export const StartConsentCheckbox = ({ checked, onChange, text, privacyUrl, invalid = false }) => {
  const { t } = useTranslation();
  return (
    <Checkbox
      className={[styles.consent, styles.startConsent, invalid ? styles.consentInvalid : ""]
        .filter(Boolean)
        .join(" ")}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      aria-required="true"
      aria-invalid={invalid || undefined}
    >
      {text}
      {privacyUrl ? (
        <>
          {" "}
          <a href={privacyUrl} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
            {t("surveyManagement.public.start_consent_privacy")}
          </a>
        </>
      ) : null}
    </Checkbox>
  );
};

export default ConsentCheckbox;
